import generateHlsJsEventHandlers, {
  HLSjsPlayer
} from './generateHlsJsEventHandlers';
import logger from '../../log';
import { CleanupMethod } from '../BaseInteraction';
import { TechApi, bindTechApiFunction } from '../../bootloader/tech';
import { TechEngagementMethods } from '../../common/Reporter/constants';

const log = logger.getLogger(__filename);

const { AUDIOCHANGED, BITRATECHANGED, CAPTIONCHANGED } = TechEngagementMethods;

const attachHlsEvents = (hls: HLSjsPlayer, tech: TechApi): CleanupMethod => {
  if (typeof hls.on !== 'function') {
    log.warn('Unable to set up HLS event handlers. Missing "on" function');
    return () => undefined;
  }
  const {
    handlers,
    audioChangeHandler,
    bitrateChangeHandler,
    captionChangeHandler
  } = generateHlsJsEventHandlers(hls);
  const teardownMap: Record<string, CleanupMethod> = {};
  bindTechApiFunction(tech, BITRATECHANGED, teardownMap, bitrateChangeHandler);
  bindTechApiFunction(tech, CAPTIONCHANGED, teardownMap, captionChangeHandler);
  bindTechApiFunction(tech, AUDIOCHANGED, teardownMap, audioChangeHandler);

  Object.entries(handlers).forEach(([eventName, handler]) => {
    hls.on(eventName, handler);
  });

  return () => {
    Object.values(teardownMap).forEach(func => func());
    if (hls.off) {
      Object.entries(handlers).forEach(([name, handler]) => {
        hls.off(name, handler);
      });
    }
  };
};

export default attachHlsEvents;
